import ApiEndpoints from '@/utils/ApiEndpoints';
import statusesId from '@/constants/statusesId';
export default {
    data () {
        return {
            statusesId,
            hasPermissionForSheetEdit: null
        };
    },
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        statusId () {
            return this.family && this.family.status.family_edition_status_id;
        },
        isPostMeetingConsentSet () {
            if (this.statusId === this.statusesId.NOT_ATTRIBUTED) {
                return false;
            }
            return !!this.family.post_meeting_consent_file;
        },
        postMeetingConsentUrl () {
            if (this.isPostMeetingConsentSet) {
                return ApiEndpoints.get('post_meeting_consent', {
                    familyEditionId: this.familyId
                });
            }
            return null;
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', this.permissions.SHEET_EDIT).then((result) => {
            this.hasPermissionForSheetEdit = result;
        });
    }
};
